import React from "react";
import { FaGithub, FaLinkedin, FaTwitter, FaEnvelope } from "react-icons/fa";
import profile from "../images/profile.png"; // add your image

export default function DeveloperCard() {
    return (
        <div className="dev-container">

            <div className="dev-card">

                {/* LEFT SIDE */}
                <div className="dev-left">
                    <div className="profile-wrapper">
                        <img src={profile} alt="developer" />
                        <span className="online-dot"></span>
                    </div>

                    <h2 className="helo">Hi, I'm</h2>
                    <h1>Singu Vishal</h1>
                    <p className="role">Full Stack Developer 🚀</p>
                    <p className="desc">
                        I build fast, scalable and modern web applications.
                    </p>
                </div>

                {/* RIGHT SIDE */}
                <div className="dev-right">
                    <div className="badge">Developer &lt;/&gt;</div>
                    <h2 className="heading">
                        Let’s Build Something <span>Amazing</span> Together ✨
                    </h2>

                    <p className="sub">
                        Open for freelance projects, collaborations and innovative ideas.
                    </p>
                    <p className="sub">
                        Let’s connect and create something amazing together.
                    </p>
                    {/* CONTACT BOXES */}
                    <div className="info-grid">

                        <div className="info-box">
                            <FaEnvelope />
                            <div>
                                <h4>Email</h4>
                                <p>singuvishal123@email.com</p>
                            </div>
                        </div>

                        <div className="info-box">
                            📞
                            <div>
                                <h4>Phone</h4>
                                <p>+91 9959582504</p>
                            </div>
                        </div>

                        <div className="info-box">
                            📍
                            <div>
                                <h4>Location</h4>
                                <p>Hyderabad, India</p>
                            </div>
                        </div>

                    </div>

                    {/* SOCIAL
                    <div className="social">
                        <FaGithub />
                        <FaLinkedin />
                        <FaTwitter />
                        <FaEnvelope />
                    </div> */}

                    {/* STATUS */}
                    <div className="open">
                        ❤️ Open to Work <br />
                        <span>Available for new opportunities</span>
                    </div>

                </div>

            </div>

            <style>{`

/* BACKGROUND */
.dev-container {
  background: radial-gradient(circle at top, #0f172a, #020617);
  padding: 100px 10%;
  display: flex;
  justify-content: center;
}

/* CARD */
.dev-card {
  display: flex;
  gap: 40px;
  width: 100%;
  max-width: 1100px;
  padding: 40px;
  border-radius: 20px;

  /* glass effect */
  background: rgba(255,255,255,0.05);
  backdrop-filter: blur(15px);

  border: 1px solid rgba(255,255,255,0.1);
  box-shadow: 0 0 40px rgba(34,197,94,0.2);
}

/* LEFT */
.dev-left {
  flex: 1;
  text-align: center;
}

.profile-wrapper {
  position: relative;
  width: 150px;
  margin: auto;
}

.profile-wrapper img {
  width: 150px;
  border-radius: 50%;
  border: 3px solid transparent;

  background: 
    linear-gradient(#000, #000) padding-box,
    linear-gradient(135deg, #22c55e, #3b82f6, #a855f7, #ec4899) border-box;
}
.online-dot {
  position: absolute;
  bottom: 10px;
  right: 10px;
  width: 15px;
  height: 15px;
  background: #22c55e;
  border-radius: 50%;
  border: 2px solid black;
}
.helo{
color:white;
}
.dev-left h1 {
  font-size: 32px;
  color: #22c55e;
  font-weight: 700;
  text-shadow: 0 0 3px rgba(75, 75, 75, 0.79);
}
  /* BADGE */
.badge {
  display: inline-block;
  padding: 6px 14px;
  border-radius: 20px;
  font-weight: 600;
  background: linear-gradient(90deg, #8b5cf6, #3b82f6);
  font-size: 14px;
  margin-bottom: 15px;
}

.role {
  font-weight: 600;
  margin: 10px 0;
  color: white;
}

.desc {
  background: linear-gradient(to right, #f8a241, #41eff8, #eff841, #f057db);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent; /* important */
}

/* RIGHT */
.dev-right {
  flex: 2;
  color: white;
}

.heading {
  color: white;
}
.heading span {
  color: #22c55e;
}

.sub {
  margin-bottom: 20px;
  opacity: 0.8;
}

/* GRID */
.info-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
}

/* BOX */
.info-box {
  display: flex;
  gap: 10px;
  align-items: center;
  background: rgba(210, 198, 198, 0.05);
  padding: 15px;
  border-radius: 10px;
  transition: 0.3s;
}

.info-box:hover {
  background: rgba(34,197,94,0.2);
}

/* SOCIAL */
.social {
  margin-top: 20px;
  display: flex;
  gap: 15px;
}

.social svg {
  background: rgba(255,255,255,0.1);
  padding: 10px;
  border-radius: 50%;
  cursor: pointer;
  transition: 0.3s;
}

.social svg:hover {
  background: #22c55e;
}
  /* OPEN TO WORK */
.open {
  margin-top: 25px;
  padding: 12px;
  text-align: center;
  border-radius: 15px;
  font-weight: bold;
  color: white;

  border: 2px solid transparent;

  background: 
    linear-gradient(#020617, #242525) padding-box,  /* inner background */
    linear-gradient(90deg, #4ca1fb, #f8de4e) border-box; /* border gradient */
}

.open span {
  display: block;
  font-size: 13px;
  opacity: 0.8;
}

/* STATUS */
.status {
  margin-top: 20px;
  padding: 12px;
  border-radius: 10px;
  text-align: center;
  background: linear-gradient(90deg, #22c55e, #16a34a);
  font-weight: 600;
}

/* MOBILE */
@media(max-width:900px){
  .dev-card {
    flex-direction: column;
    text-align: center;
  }

  .info-grid {
    grid-template-columns: 1fr;
  }
}

      `}</style>
        </div>
    );
}